import { DirectoryAutocompleteField } from 'features';
import { lodash } from 'helpers';
import { useIsFormEditable } from 'hooks';
import { formatDecimalValue } from 'libs/form/fields/DecimalField/helpers';
import { useTranslation } from 'libs/i18n';
import { Input } from 'libs/ui';
import { OrderSection } from 'modules/order/common/components';
import { MAX_FLOATING_POINTS } from 'modules/order/common/constants';
import { Field } from 'modules/order/common/forms/orderForm';

import { useTransactionVolumeSection } from './useTransactionVolumeSection';

export const TransactionVolumeSection = () => {
  const { t } = useTranslation();

  const {
    isDisabledUnitPrice,
    isTransactionAmountDisabled,
    currencies,
    nominalQuantity,
  } = useTransactionVolumeSection();

  const isEditable = useIsFormEditable();

  return (
    <OrderSection
      fields={lodash.compact([
        <Field.Quantity
          fullWidth
          showRequiredMark
          label={t(
            'order.sections.transactionVolumeSection.fields.quantity.label'
          )}
          name="transactionVolume.quantity"
          placeholder={t(
            'order.sections.transactionVolumeSection.fields.quantity.placeholder'
          )}
        />,
        <Input
          fullWidth
          readOnly
          disabled={isEditable}
          label={t(
            'order.sections.transactionVolumeSection.fields.nominalQuantity.label'
          )}
          name="transactionVolume.nominalQuantity"
          value={formatDecimalValue(nominalQuantity, MAX_FLOATING_POINTS, 0)}
        />,
        <Field.Decimal
          fullWidth
          disabled={!isEditable ? false : isDisabledUnitPrice}
          label={t(
            'order.sections.transactionVolumeSection.fields.unitPrice.label'
          )}
          maxFloatingPoints={MAX_FLOATING_POINTS}
          name="transactionVolume.unitPrice"
          placeholder={
            isDisabledUnitPrice
              ? undefined
              : t(
                  'order.sections.transactionVolumeSection.fields.unitPrice.placeholder'
                )
          }
          showRequiredMark={!isDisabledUnitPrice}
        />,
        currencies ? (
          <DirectoryAutocompleteField<{ value: string; label: string }, false>
            fullWidth
            showRequiredMark
            directorySchemaName={currencies.currency.directorySchemaName}
            fieldName={currencies.currency.fieldName}
            label={t(
              'order.sections.transactionVolumeSection.fields.currency.label'
            )}
            name="transactionVolume.currency"
            placeholder={t(
              'order.sections.transactionVolumeSection.fields.currency.placeholder'
            )}
          />
        ) : (
          <Field.Text
            fullWidth
            readOnly
            disabled={isEditable}
            label={t(
              'order.sections.transactionVolumeSection.fields.currency.label'
            )}
            name="transactionVolume.currency.label"
          />
        ),

        <Field.Decimal
          fullWidth
          disabled={!isEditable ? false : isTransactionAmountDisabled}
          label={t(
            'order.sections.transactionVolumeSection.fields.transactionAmount.label'
          )}
          maxFloatingPoints={MAX_FLOATING_POINTS}
          maxIntegerLength={0}
          name="transactionVolume.transactionAmount"
          placeholder={
            !isDisabledUnitPrice
              ? t(
                  'order.sections.transactionVolumeSection.fields.transactionAmount.placeholder'
                )
              : undefined
          }
          showRequiredMark={!isDisabledUnitPrice}
        />,
      ])}
      title={t('order.sections.transactionVolumeSection.title')}
    />
  );
};
